import { render, staticRenderFns } from "./ActivitiesSection.vue?vue&type=template&id=bc0b0faa&"
import script from "./ActivitiesSection.vue?vue&type=script&lang=js&"
export * from "./ActivitiesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports